import Phaser from "phaser";
import React, {
  useContext,
  useReducer,
  useCallback,
  useEffect,
  useState,
  useRef
} from "react";
import * as log from "loglevel";
import axios from "axios";
import Player from "@vimeo/player";
import * as wordsObject from "../words";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import * as PIXI from "pixi.js";
import { sound } from "@pixi/sound";
import { GameContext, fnLib } from "../Game";

const words = [];
Object.keys(wordsObject).forEach((key) => {
  words.push(wordsObject[`${key}`]);
});
log.setLevel(log.levels.DEBUG);

export default function VideoGrid(props) {
  const [vimeoData, setVimeoData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const gameContext = useContext(GameContext);
  const [keywords, setKeywords] = useState([]);
  const videoRef = useRef(null);
  const playAll = async () => {
    let iframes = window.document.querySelectorAll(`.playbern-video`);
    log.debug("playing all videos", { iframes });
    if (iframes) {
      for (let i = 0; i < iframes.length; i++) {
        await new Promise((res) => {
          const vidIframe = iframes[i];
          var player = new Player(vidIframe);
          player.on("play", function () {
            console.log("Played the video");
          });
          player.getVideoTitle().then(function (title) {
            console.log("title:", title);
          });
          player.setAutopause(false);
          player.play();
          res();
          /* setTimeout(() => {
            player.pause();
            res();
          }, 3000) */
        });
      }
    }
  };
  const stopAll = async () => {
    let iframes = window.document.querySelectorAll(`.playbern-video`);
    log.debug("playing all videos", { iframes });
    if (iframes) {
      for (let i = 0; i < iframes.length; i++) {
        await new Promise((res) => {
          const vidIframe = iframes[i];
          var player = new Player(vidIframe);
          player.on("play", function () {
            console.log("Played the video");
          });
          player.getVideoTitle().then(function (title) {
            console.log("title:", title);
          });
          player.setAutopause(false);
          player.pause();
          res();
          /* setTimeout(() => {
            player.pause();
            res();
          }, 3000) */
        });
      }
    }
  };
  useEffect(() => {
    const update = async () => {
      let nrOfVideos = 10;
      let wordsAudio = gameContext.inputs.audio
        .join(" ")
        .split(/(\s+)/)
        .filter((w) => w.length > 3);
      let wordsKeyboard = gameContext.inputs.keyboard
        .split(/(\s+)/)
        .filter((w) => w.length > 3);
      let allWords = [...wordsAudio, ...wordsKeyboard];
      const shuffled = allWords.sort(() => 0.5 - Math.random());
      let selected = shuffled;
      if (shuffled.length >= nrOfVideos) {
        selected = shuffled.slice(0, nrOfVideos);
      }
      let defaultWords = [
        "dogs",
        "cats",
        "kids",
        "wedding",
        "meme",
        "jackass",
        "joke",
        "fails",
        "sport",
        "skateboard"
      ];
      for (let i = 0; i < nrOfVideos; i++) {
        if (selected[i] === undefined) {
          selected[i] = defaultWords[i];
        }
      }
      selected = [...new Set(selected)];
      setKeywords(selected);
      selected = selected.map((s) => `funny ${s}`);
      log.debug("searching video for words", {
        allWords,
        wordsAudio,
        wordsKeyboard,
        shuffled,
        selected
      });
      setIsLoading(true);
      let promises = [];
      for (let i = 0; i < selected.length; i++) {
        const req = fnLib
          .searchVimeoVideos(
            `?sort=plays&direction=desc&query=${encodeURIComponent(
              selected[i]
            )}&minimum_likes=200&trending=true`
          )
          .catch((e) => {
            setIsLoading(false);
          });
        promises.push(req);
      }
      let newVimeoData = await Promise.all(promises);
      setIsLoading(false);
      log.debug("playing all videos", { newVimeoData });
      let finalArray = [];
      newVimeoData
        .filter((vd) => !!vd === true)
        .forEach((vd) => {
          let selectedVideo = vd
            .filter(
              (v) =>
                !!v === true &&
                !!v.stats &&
                v.stats.plays &&
                v.embed &&
                v.embed.html
            )
            .sort((a, b) => {
              if (a.stats.plays || 0 > b.stats.plays || 0) {
                return 1;
              } else if (a.stats.plays || 0 <= b.stats.plays || 0) {
                return -1;
              } else {
                return 0;
              }
            })[0];
          finalArray.push(selectedVideo);
        });
      setVimeoData(finalArray);
    };
    update();
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        textAlign: "center"
      }}
    >
      {!isLoading ? (
        <React.Fragment>
          <Typography variant="h3">Videos On Your Blog Post</Typography>
          <Button onClick={playAll}>
            <Typography variant="h4">play</Typography>
          </Button>
          <Button onClick={stopAll}>
            <Typography variant="h6">Stop</Typography>
          </Button>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              color: "cyan"
            }}
          >
            {keywords.map((k, i) => (
              <span key={`${k}_${i}`}>
                <Typography variant="body1">{`#${k}`}</Typography>&nbsp;
              </span>
            ))}
          </div>
        </React.Fragment>
      ) : null}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {(() => {
          if (!isLoading) {
            // total score
            let score = vimeoData.reduce((acc, curr) => {
              return acc + ((curr && curr.stats && curr.stats.plays) || 0);
            }, 0);
            return (
              <Typography style={{ color: "springgreen" }} variant="h4">
                Your score: {score.toLocaleString("de-CH")}
              </Typography>
            );
          }
        })()}
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {(() => {
          if (!isLoading) {
            // total score
            let score = vimeoData.reduce((acc, curr) => {
              return acc + ((curr && curr.stats && curr.stats.plays) || 0);
            }, 0);
            return (
              <div>
                <iframe
                  src="https://giphy.com/embed/fdyZ3qI0GVZC0"
                  width="480"
                  height="270"
                  frameBorder="0"
                  class="giphy-embed"
                  allowFullScreen
                ></iframe>
              </div>
            );
          }
        })()}
      </div>
      <br />
      <br />
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {vimeoData
          .filter((vd) => !!vd && vd.uri)
          .map((vd) => {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <iframe
                  key={vd.uri}
                  title="vimeo-video"
                  className="playbern-video"
                  src={`https://player.vimeo.com/video/${vd.uri.replace(
                    "/videos/",
                    ""
                  )}`}
                  frameBorder="0"
                  allow="autoplay"
                ></iframe>
                <Typography variant="h6">{vd.name}</Typography>
                <Typography variant="h5">
                  Views: {(vd.stats.plays || 0).toLocaleString("de-CH")}
                </Typography>
              </div>
            );
          })}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {isLoading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <CircularProgress />
            <Typography variant="h5">Please hang on</Typography>
            <iframe
              src="https://giphy.com/embed/o0vwzuFwCGAFO"
              width="480"
              height="480"
              frameBorder="0"
              class="giphy-embed"
              allowFullScreen
            ></iframe>
          </div>
        ) : null}
      </div>
    </div>
  );
}
